// extracted by mini-css-extract-plugin
export default {"priorities":"PrioritiesList_priorities__BXQoY","priority":"PrioritiesList_priority__dczhN","selectedPriority":"PrioritiesList_selectedPriority__SaGJY"};